import Button from "devextreme-react/button";
import LoadPanel from "devextreme-react/load-panel";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import React, { useState } from "react";
import { syncDcStatuses } from "../../api/v2/StatusSyncApi";
import { useAppContext } from "../shared/AppContext";

// Temporary: one-time catch-up of DC task/subtask statuses from their files. Previews the changes,
// then applies them on confirmation.
export default function DcStatusSyncButton() {
    const app = useAppContext();
    const [changes, setChanges] = useState<string[] | null>(null);
    const [running, setRunning] = useState(false);

    const run = async (apply: boolean) => {
        setRunning(true);
        const result = await syncDcStatuses(apply);
        setRunning(false);

        if (result.error) {
            app.errorToast(result.error.message);
            return;
        }

        if (apply) {
            app.infoToast(`Applied ${result.data!.length} changes`);
            setChanges(null);
        } else {
            setChanges(result.data!);
        }
    };

    return (
        <>
            <Button text="Sync DC Statuses" stylingMode="outlined" onClick={() => run(false)} disabled={running} />

            <LoadPanel visible={running} message="Replaying DC files..." />

            <Popup
                visible={changes != null}
                onHiding={() => setChanges(null)}
                title={`DC status sync preview (${changes?.length ?? 0} changes)`}
                width={900}
                height="80vh"
            >
                <ScrollView height="100%">
                    {changes?.length === 0
                        ? <p>Nothing to change.</p>
                        : <pre style={{ fontSize: 12 }}>{changes?.join("\n")}</pre>}
                </ScrollView>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text: "Apply", type: "default", disabled: running || !changes?.length, onClick: () => run(true) }}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text: "Close", onClick: () => setChanges(null) }}
                />
            </Popup>
        </>
    );
}
